import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ExternalCollaboratorUserLozenge: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExternalUserLozenge" */ '../src/ExternalUserLozenge.tsx'
			)
		).ExternalUserLozenge,
});
